import styled from 'styled-components';
import { breakpoints, sizes, theme } from 'theme';
import strings from 'strings/strings.json';
import { ErrorNotifier } from 'components/notifiers/ErrorNotifier';
import { APIError, ApiResponse } from '../../../lib/_api-helpers';
import { LearnerCourseContext } from 'contextProviders/LearnerCourseContext';
import { useContext } from 'react';
import { FlexCenter, FlexJustifyCenter } from 'components/Elements';
import Button from 'components/buttons/Button';

type MarkAsCompleteCardProps = {
    completed: boolean;
    toggleTaskCompletion: () => Promise<ApiResponse<boolean>>;
    toggleCompletionErrors: APIError[];
};

export default function MarkAsCompleteCard({
    toggleTaskCompletion,
    completed,
    toggleCompletionErrors,
}: MarkAsCompleteCardProps): JSX.Element {
    const { isFinalActivity } = useContext(LearnerCourseContext);

    if (toggleCompletionErrors.length > 0 || toggleCompletionErrors.length > 0) {
        return (
            <GreenBanner>
                <Content $completed={false}>
                    <ErrorNotifierContainer>
                        <ErrorNotifier
                            title={strings.taskPage.markAsComplete.errorTitle}
                            description={strings.taskPage.markAsComplete.errorDescription}
                            maxWidth={'100%'}
                        />
                    </ErrorNotifierContainer>
                </Content>
            </GreenBanner>
        );
    }

    return (
        <GreenBanner>
            <Content $completed={completed}>
                {completed ? (
                    <Button
                        title={strings.taskPage.markAsComplete.incompleteButtonTitle}
                        aria={strings.taskPage.markAsComplete.incompleteButtonAria}
                        onClick={toggleTaskCompletion}
                    />
                ) : (
                    <Button
                        title={
                            isFinalActivity
                                ? strings.taskPage.markAsComplete.completeCourseButtonTitle
                                : strings.taskPage.markAsComplete.completeButtonTitle
                        }
                        aria={strings.taskPage.markAsComplete.completeButtonAria}
                        colour='PRIMARY'
                        onClick={toggleTaskCompletion}
                    />
                )}
            </Content>
        </GreenBanner>
    );
}

const ErrorNotifierContainer = styled.div`
    width: 100%;
`;

const Content = styled(FlexCenter)<{ $completed: boolean }>`
    gap: ${sizes.spacingRg};
    width: 900px;
    background-color: ${({ $completed }) =>
        $completed ? theme.learnerActivityCard.completedNotificationBackground : theme.cardBackground};
    margin: ${sizes.spacingLg} 0;
    padding: ${sizes.spacingLg};
    border-radius: ${sizes.borderRadiusLg};

    transition:
        background-color 200ms ease,
        border-color 200ms ease,
        box-shadow 200ms ease;

    @media (max-width: ${breakpoints.md}) {
        padding: ${sizes.spacingLg} ${sizes.spacingMd};
        width: 90%;
    }

    @media (max-width: ${breakpoints.sm}) {
        flex-direction: column;
        padding: ${sizes.spacingMd} ${sizes.spacingMd};
    }
`;

const GreenBanner = styled(FlexJustifyCenter)`
    width: 100%;
    background-color: ${theme.learnerActivityCard.completedBackground};
    height: 160px;
`;
